/** @typedef {'list'|'fixture'|'selected'|'membership'} DeliveryLane */
/** @typedef {number & {readonly __frameSequence: unique symbol}} FrameSequence */
/** Existing owner tokens, never generated authorization or domain identities. */
export const sameFrameOwner = (a, b) => !!a && !!b
  && Object.keys(a).length === Object.keys(b).length
  && Object.keys(a).every(key => a[key] === b[key]);
/** @returns {FrameSequence | null} */
export const frameSequence = value => Number.isSafeInteger(value) && value > 0
  ? /** @type {FrameSequence} */ (value) : null;
